export default __webpack_public_path__ + "navigation-examples-embedded-navigation-v1-1200-330bdefbf06de642b469a78f2cf71445.webp";